<div style="text-align: center">
  <h1 style="font-family: Exo, sans-serif; font-weight: bold; padding-top: 10px" mat-dialog-title>Attenzione!</h1>
  <div mat-dialog-content style="padding-top: 5px">
    <ng-container *ngFor="let s of message">
      <p>{{s}}<br></p>
    </ng-container>
  </div>
  <div mat-dialog-actions style="justify-content: center;">
    <button mat-raised-button color="primary" [mat-dialog-close]="response">Conferma</button>
    <button mat-raised-button color="warn" (click)="cancel()">Annulla</button>
  </div>
</div>
